export enum PatientStatus {
  ACTIVE_TREATMENT = 'Active Treatment',
  DISCONTINUED = 'Discontinued'
}

export enum PatientDocumentType {
  ADVERSE_EVENT_FORM = 'aef'
}
